<template>
  <div class="form-collapse layer-saveBpm">
    <div class="info">
      <layui-form ref="saveTemplate" :rule="form_rule" :outside="outside">
        <div class="layui-form">
          <layui-collapse ref="collapse">
            <div class="layui-colla-item">
              <!-- <h2 class="layui-colla-title">模板基本信息</h2> -->
              <div class="layui-colla-content layui-show">
                <div class="layui-form-item">
                  <pub-form :config="config" direction="vertical" />
                </div>
              </div>
            </div>
          </layui-collapse>
        </div>
        <div class="layui-form-btn">
          <button class="layui-btn refresh" title="关闭" @click="handleBtnclick('close')">
            关 闭
          </button>
          <button class="layui-btn" title="保存" @click="handleBtnclick('save')">
            保 存
          </button>
        </div>
      </layui-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SaveBpm',
  props: {
    beforeSaveFn: { type: Function },
    info: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      outside: undefined,
      form_rule: {
        TEMPLATE_NAME: {
          required: { message: '模板名称不能为空' }
        },
        TEMPLATE_NODE: {
          required: { message: '模板内容不能为空' }
        }
      },
      config: {
        render: [
          { required: true, label: '模板名称', children: [{ type: 'input', name: 'TEMPLATE_NAME' }] },
          { label: '模板备注', children: [{ type: 'textarea', name: 'BZ' }] }
        ],
        form: {
          TEMPLATE_NAME: this.info.tplName || '',
          BZ: this.info.tplBZ || '',
          TEMPLATE_NODE: null,
          DRAGTMPLATE_NODE: null
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.outside = '.bpm-content'
      this.$refs.saveTemplate.openPopRight(null, 'auto', this.close_callBack, $(this.outside), '模板信息')
    })
  },
  methods: {
    /**
     * form弹窗关闭的回调
     */
    close_callBack() {
      this.$emit('update:visible', false)
    },
    /**
     * 保存、关闭
     */
    handleBtnclick(type) {
      switch (type) {
        case 'close': {
          this.$emit('update:visible', false)
          this.$refs.saveTemplate.close()
          break
        }
        case 'save': {
          let obj = Object.assign({}, this.config.form)

          this.beforeSaveFn && this.beforeSaveFn(obj)

          obj.TEMPLATE_NODE = this.$parent.bpmData
          if (!obj.TEMPLATE_NODE.length) {
            layer.msg('模板节点不能为空', { icon: 5, shift: 6, targetEl: $(this.outside) })
            return
          }

          this.$refs.saveTemplate.editRow = obj
          this.$refs.saveTemplate.save('YW_TEMPLATE', 'templateLoad', (res) => {
            this.$refs.saveTemplate.close()
            this.$bus.$emit('templateLoad')
            this.$bus.$emit('hideBpm')
          }, (err) => {
            // this.$refs.saveTemplate.close()
          })
          break
        }
        default: {
          break
        }
      }
    }
  }
}
</script>

<style lang="postcss">
.layer-saveBpm {
  & .layui-layer-wrap {
    height: 100%;
    overflow: auto;
  }
  & .layui-form-item {
    margin: 0;
    /* padding-bottom: 16px; */
  }
  & .layui-form-label {
    width: auto;
    padding: 9px 0;
    color: #333;
    font-weight: 500;
  }
  & .file-upload {
    height: 32px;
    line-height: 32px;
    background: #fff;
    margin-top: 7px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/workOrder/newBpm/saveBpm.vue